var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('alert-component',{attrs:{"alert":_vm.alerts.expire_message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }